// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__bdiRm","socialMedia":"Footer_socialMedia__xjbHr","socialIcon":"Footer_socialIcon__0felB","socialImage":"Footer_socialImage__pPi1M"};